export default "__VITE_ASSET__DlJ1qQiS__"